export default __webpack_public_path__ + "static/media/faq-group-icon.9b4e73ab.svg";